import { WidgetGridLayout } from '@dawn/ui';

import { useResolvedWidgets } from '@/hooks/use-resolved-widgets';

import { WIDGETS } from './widgets';

export function WidgetGrid() {
  const widgets = useResolvedWidgets();
  return (
    <WidgetGridLayout
      // ponytail: the EPM-142 floor. 1280 viewport − 210 sidebar − 2×20 padding − a ~17px
      // classic scrollbar (Windows 17, macOS "always show" 15), rounded down.
      className="min-w-[1010px] items-stretch"
      data-testid="dashboard-grid"
    >
      {widgets.map((widget) => {
        const WidgetComponent = WIDGETS[widget.type];
        if (!WidgetComponent) return null;
        return <WidgetComponent key={widget.id} config={widget} />;
      })}
    </WidgetGridLayout>
  );
}
